import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProductFormComponent } from './components/product-form/product-form.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { CartComponent } from './components/cart/cart.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { PublicHomeComponent } from './components/public-home/public-home.component';
import { AdminCategoriesComponent } from './admin-categories/admin-categories.component';
import { CategoryFormComponent } from './category-form/category-form.component';
import { AuthGuard } from './guards/auth.guard';
import { VendorProductManagementComponent } from './components/vendor-product-management/vendor-product-management.component';
import { VendorProfileComponent } from './components/vendor-profile/vendor-profile.component';
import { VendorRegisterComponent } from './components/vendor-register/vendor-register.component';
import { AdminOrderStatusComponent } from './dashboard/orders/admin-order-status.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OverviewComponent } from './dashboard/overview/overview.component';
import { VendorsComponent } from './dashboard/vendors/vendors.component';
import { RoleGuard } from './guards/role.guard';
import { UsersComponent } from './users/users.component';
import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { TrackingDetailsComponent } from './tracking-details/tracking-details.component';
import { CustomerOrdersComponent } from './customer-orders/customer-orders.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';

const routes: Routes = [
  { path: '', component: PublicHomeComponent },
  { path: 'shop', component: PublicHomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'admin/products', component: ProductListComponent },
  { path: 'admin/CreateProduct', component: ProductFormComponent },
  { path: 'admin/product/edit/:id', component: ProductFormComponent },
  { path: 'admin/product/:id', component: ProductDetailComponent },
  { path: 'cart', component: CartComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'order-confirmation/:id', component: OrderConfirmationComponent },

  { path: 'admin/categories', component: AdminCategoriesComponent },
  { path: 'admin/categories/create', component: CategoryFormComponent },
  { path: 'admin/categories/edit/:id', component: CategoryFormComponent },
  { path: 'admin/vendor-register', component: VendorRegisterComponent },

  { path: 'orders/track/:trackingNumber', component: OrderTrackingComponent },
  { path: 'order-tracking/:id', component: TrackingDetailsComponent },
  { path: 'my-orders', component: CustomerOrdersComponent },

  { path: 'payment-success/:orderId', component: PaymentSuccessComponent },
  { path: 'payment-failed/:orderId', component: PaymentFailedComponent },

  { path: 'products/add', component: ProductFormComponent },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'overview', component: OverviewComponent },
      { path: 'vendors', component: VendorsComponent, canActivate: [RoleGuard], data: { roles: ['Admin'] } },
      { path: 'users', component: UsersComponent, canActivate: [RoleGuard], data: { roles: ['Admin'] } },
      { path: 'products', component: VendorProductManagementComponent, canActivate: [RoleGuard], data: { roles: ['Vendor'] } },
      { path: 'orders', component: AdminOrderStatusComponent, canActivate: [RoleGuard], data: { roles: ['Admin', 'Vendor'] } },
      { path: 'profile', component: VendorProfileComponent, canActivate: [RoleGuard], data: { roles: ['Admin', 'Vendor', 'User'] } }
    ],
    data: { roles: ['Admin', 'Vendor', 'User'] }
  }
];




@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
